import React from 'react';
import { HoverTooltip } from '@/core/HoverTooltip.atom';
import { getAllItems } from '@/trend/trendDataHelper.utilities';
import _ from 'lodash';
import { sqItemsApi } from '@/sdk/api/ItemsApi';
import { useFlux } from '@/core/hooks/useFlux.hook';
import classNames from 'classnames';
import {
  sqTrendConditionStore,
  sqTrendMetricStore,
  sqTrendScalarStore,
  sqTrendSeriesStore,
  sqTrendTableStore,
} from '@/core/core.stores';
import { addTrendItem } from '@/trendData/trend.actions';
import { TooltipPosition } from '@seeqdev/qomponents';

interface AddToDisplayPaneIF {
  itemId: string;
  tooltip?: string;
  extraClassNames?: string;
  tooltipPlacement?: TooltipPosition;
  afterAdd?: (itemId: string) => Promise<void> | void;
  outputItemId?: string;
}

export const AddToDisplayPane: React.FunctionComponent<AddToDisplayPaneIF> = (props) => {
  const { itemId, tooltip, extraClassNames, tooltipPlacement, afterAdd, outputItemId } = props;

  // getAllItems uses these stores to source items, so we must respond to changes in those stores
  useFlux(sqTrendSeriesStore);
  useFlux(sqTrendScalarStore);
  useFlux(sqTrendConditionStore);
  useFlux(sqTrendTableStore);
  useFlux(sqTrendMetricStore);

  const trendItems = getAllItems({});

  if (_.some(trendItems, { id: itemId })) {
    return null;
  }

  const addToDisplay = () => {
    let scalingItemProps: object;
    if (outputItemId) {
      const outputItem = _.find(trendItems, { id: outputItemId });
      scalingItemProps = {
        tableId: _.get(outputItem, 'tableId'),
        rowId: _.get(outputItem, 'rowId'),
        columnId: _.get(outputItem, 'columnId'),
      };
    }
    sqItemsApi
      .getItemAndAllProperties({ id: itemId })
      .then(({ data: item }) => addTrendItem(item, scalingItemProps))
      .then(() => (afterAdd ? afterAdd(itemId) : undefined));
  };

  return (
    <HoverTooltip placement={tooltipPlacement || 'right'} text={tooltip || 'ADD_TO_DISPLAY'}>
      <a
        data-testid="addToDisplay"
        className={classNames(
          'displayIcon a fa-sharp fa-regular fa-chart-area link-no-underline animated animate-if-opacity pt2 pl5' +
            ' force-link-color',
          extraClassNames,
        )}
        onClick={addToDisplay}
      />
    </HoverTooltip>
  );
};
